import { render, staticRenderFns } from "./RightPanel.vue?vue&type=template&id=17795e15&scoped=true"
import script from "./RightPanel.vue?vue&type=script&lang=js"
export * from "./RightPanel.vue?vue&type=script&lang=js"
import style0 from "./RightPanel.vue?vue&type=style&index=0&id=17795e15&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17795e15",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yanchenrong/code/youxiang/muying/mall-super-admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17795e15')) {
      api.createRecord('17795e15', component.options)
    } else {
      api.reload('17795e15', component.options)
    }
    module.hot.accept("./RightPanel.vue?vue&type=template&id=17795e15&scoped=true", function () {
      api.rerender('17795e15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FormGenerator/index/RightPanel.vue"
export default component.exports